import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const addBank = catchAsync(async (body) => {
    const { data } = await axiosInstance.post(
      `/api/resource/Bank`,
      body
    );
    return data;
  });
export const updateBank = catchAsync(async (body, editId) => {
    const { data } = await axiosInstance.put(
      `/api/resource/Bank/${editId}`,
      body
    );
    return data;
  });

  export const getBank = catchAsync(async (lang) => {
    const { data } = await axiosInstance.get(
        `/api/resource/Bank?fields=["name","swift_number"]`
    );
    return data;
  });
  export const getBankDetails = catchAsync(async (id) => {
    const { data } = await axiosInstance.get(
      `/api/resource/Bank/${id}`
    );
    return data;
  });
  export const deleteBank = catchAsync(async (id) => {
    const { data } = await axiosInstance.delete(
      `/api/resource/Bank/${id}`
    );
    return data;
  });